import { Middleware, configureStore } from '@reduxjs/toolkit';
import { logger } from 'redux-logger';
import apiMiddleware from './middlewares/api';
//import articleMiddleware from './middlewares/article';
import rootReducer from './reducers';

export type RootReducerType = typeof rootReducer;

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      logger,
      apiMiddleware as Middleware,
      //articleMiddleware as Middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
